(() => {
  const params = new URLSearchParams(window.location.search);
  const subId = params.get("sub_id");

  // URL 没有 sub_id 时，不修改已有 Cookie
  if (!subId) return;

  const expires = new Date();
  expires.setMonth(expires.getMonth() + 3);

  document.cookie = [
    `sub_id=${encodeURIComponent(subId)}`,
    `expires=${expires.toUTCString()}`,
    "path=/",
    "SameSite=Lax",
    "Secure",
  ].join("; ");
})();
